var map = {
	"./ai.svg": 1944,
	"./avi.svg": 1945,
	"./css.svg": 1946,
	"./csv.svg": 1947,
	"./dbf.svg": 1948,
	"./doc.svg": 1949,
	"./dwg.svg": 1950,
	"./exe.svg": 1951,
	"./fla.svg": 1952,
	"./gif.svg": 1953,
	"./html.svg": 1954,
	"./iso.svg": 1955,
	"./jpeg.svg": 1956,
	"./jpg.svg": 1957,
	"./js.svg": 1958,
	"./json.svg": 1959,
	"./mp3.svg": 1960,
	"./mp4.svg": 1961,
	"./other.svg": 1390,
	"./pdf.svg": 1962,
	"./png.svg": 1963,
	"./ppt.svg": 1964,
	"./psd.svg": 1965,
	"./rtf.svg": 1966,
	"./svg.svg": 1967,
	"./txt.svg": 1968,
	"./xls.svg": 1969,
	"./xml.svg": 1970,
	"./zip.svg": 1971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1943;